import React from 'react'

import EditUser from '@components/EditUser'

import V2AccountLayout from '../V2AccountLayout'

// Editar perfil dentro da conta V2 — o formulário V1 (EditUser, 1.000+ linhas de
// regras de cadastro/IE/endereço) é reusado POR INTEIRO com o skin `.v2-uuf`,
// como na Atualização do fluxo de compra. Pós-salvar volta à conta (ponte por
// pathname no EditUser; V1 intacto).

export default function V2ContaPerfil() {
  return (
    <V2AccountLayout>
      <div className="v2-uuf v2-acc-embed">
        <EditUser edit />
      </div>
    </V2AccountLayout>
  )
}
